import React, { useState, useRef } from 'react';
import * as S from './styles';
import { useNavigate } from 'react-router-dom';
import { ButtonCarousel } from 'components/ButtonCarousel';
import { CommentsUsers } from 'components/CommentsUsers';
import { CommentsUsersFlexHousing } from 'components/CommentsUsersFlexHousing';

export type Comments = {
    id: string;
    author: string;
    comment: string;
    type: string;
};

interface CarouselCommentsProps {
    comments: Comments[]

}

const MobileCarouselCommentsOwner: React.FC<CarouselCommentsProps> = ({ comments }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const slideRef = useRef<HTMLDivElement>(null);

    const navigate = useNavigate()

    const arrowIcon = require('assets/svg/arrowComments.svg').default;


    const nextSlide = () => {
        if (currentIndex < comments.length - 1) {
            setCurrentIndex((prev) => prev + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    };

    return (
        <S.Container>
            <S.CarouselContainer ref={slideRef}>
                {comments.slice(0, 3).map((comment, index: any) => (
                    <S.Slide
                        key={index}
                        active={index === currentIndex}>
                        <S.CarouselItem key={comment.id}>
                            <S.BackgroundContainer>
                                <h3>{comment.comment}</h3>
                                <S.UserInfo>
                                    <p>{comment.author}</p>
                                    <strong>
                                        {comment.type}
                                    </strong>
                                </S.UserInfo>
                            </S.BackgroundContainer>
                        </S.CarouselItem>
                    </S.Slide>
                ))}
            </S.CarouselContainer>
            <S.ButtonContainer>
                <S.LeftButton onClick={prevSlide} >
                    <img src={arrowIcon} alt="" />
                </S.LeftButton>
                <S.RightButton onClick={nextSlide} >
                    <img src={arrowIcon} alt="" />
                </S.RightButton>
            </S.ButtonContainer>
        </S.Container>
    );
};

export default MobileCarouselCommentsOwner;
